import { M18RnMeta as Meta } from '@kopapro-redux/utils/constant';
// copy from kopapro-redux if kopapro-redux will be sepreate module

export const M18RnMeta = Meta;
